module.exports = __webpack_public_path__ + "static/media/world.807264cf.png";